<template lang="pug">
  .croatia
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/croatia-min.png"
      )
      span {{ gettext('Хорватия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Хорваты – народ, который проживает на Балканском полуострове и является более европеизированным среди всех славянских. Когда-то Хорватия являлась частью Республики Югославия, теперь же, с 2013 года страна является членом Евро союза и активно развивает свой потенциал и экономику. Право хорватам работать в других странах ЕС может быть ограничено переходными соглашениями до 30 июня 2020 года. Большинство стран ЕС отказались от этих ограничений. Тем не менее, хорватам может потребоваться разрешение на работу в Австрии и Швейцарии.') }}
        p {{ gettext('Хорваты очень вежливы и корректны, с удовольствием согласятся помочь. Они привыкли все делать дотошно на совесть, потому что всегда отличались спокойствием и сдержанностью. ') }}
        p {{ gettext('Состоянием на 2017 год более 14% хорватов проживали в другой стране ЕС, и среди них был высокий процент работников – 79,8 %. Около 32% мобильных работников имели высшее образование. Это свидетельствует о большом интересе хорватских граждан в трудоустройстве в других странах Европейского союза. Хорватские работники являются квалифицированной рабочей силой, которая может заполнить востребованные на государственном уровне профессиональные ниши. Большинство хорватов предпочитают работать в Германии, Нидерландах, Словении, Австрии, Швейцарии, Франции, Италии, Швеции, США, Канаде и других странах.') }}
        p {{ gettext('Хорватские работники заняты в разных секторах деятельности. Они прославились как хорошие строители и социальные работники, медицинский персонал и работники сферы обслуживания. Также, хорваты работают в сфере транспорта и технологий, производства, торговли и ремесла.') }}
        p {{ gettext('Большая часть хорватов (так, как Хорватия является туристической страной, которая ежегодно встречает тысячи туристов), достаточно хорошо владеет английским языком, а также итальянским. Это заметно упрощает общение со многими иностранными гражданами в рабочих и бытовых аспектах.') }}
        p {{ gettext('Хорваты закрепили за собой положительную репутацию среди работодателей разных стран: они усидчивы, исполнительны, серьезно и ответственно подходят к работе, они сообразительны и толерантны, что делает любые рабочие отношения с ними легкими и приятными.') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/croatia-min.png'})
  },
  name: 'Croatia',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Croatia | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/croatia/index.vue